import { render, staticRenderFns } from "./PufaCredit.vue?vue&type=template&id=4a5cd528&scoped=true"
import script from "./PufaCredit.vue?vue&type=script&lang=js"
export * from "./PufaCredit.vue?vue&type=script&lang=js"
import style0 from "./PufaCredit.vue?vue&type=style&index=0&id=4a5cd528&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5cd528",
  null
  
)

export default component.exports